var modules_2fab7c71 = {"container":"_18xc156","header":"_1apgs64","hidden":"_18mw50h","title":"_3rjyp1","slides-wrapper":"_knb051","gradient":"_13bn58s","right-gradient":"_5nd5l2","left-gradient":"_1knvq3c","slides":"_1mmca5t","bottom-controls":"_4stfzv"};
import "../../../assets/1pI2Uapr.css";

export { modules_2fab7c71 as default };
//# sourceMappingURL=Carousel.module.less.js.map
